export default {
    install: (app) => {
      // console.log("> checking object");
      app.config.globalProperties.isObjectEmpty = (objectName) => {
        if(objectName == null) return true;
        return Object.keys(objectName).length === 0 && objectName.constructor === Object;
      }
    }
  }